export default __webpack_public_path__ + "static/media/the_protector_2.844155f7.png";